module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidate":"Candidate"}}')
  delete Component.options._Ctor
}
